import { IMDSCardProps, MDSCardSlotName } from "./card.types";
import { MdsIcon } from "@/design-system/components/icon/MdsIcon";
import {
  StyledButton,
  StyledCardContent,
  StyledCardHeader,
  StyledCardIcon,
  StyledCardRightAddon,
  StyledCardTitle,
  StyledCardDescription,
  StyledButtonContent,
  StyledCard,
} from "./card.style";
import { getSlots } from "@/mds/utils/slots";

export function MDSCard(props: IMDSCardProps) {
  const { onPress, ...rest } = props;

  if (onPress) {
    return (
      <StyledButton {...rest} onPress={onPress}>
        <Content {...props} />
      </StyledButton>
    );
  }

  return (
    <StyledCard>
      <Content {...props} />
    </StyledCard>
  );
}

const Content = (props: IMDSCardProps) => {
  const { mdsIcon, title, description, children } = props;

  const rightAddon = getSlots(children, MDSCardSlotName.RightAddon);
  const content = getSlots(children, MDSCardSlotName.Content);

  const hasRightAddon = rightAddon.length > 0;
  const hasContent = content.length > 0;

  return (
    <StyledButtonContent>
      <StyledCardHeader>
        {mdsIcon && (
          <StyledCardIcon>
            <MdsIcon kind={mdsIcon} />
          </StyledCardIcon>
        )}
        {title && <StyledCardTitle>{title}</StyledCardTitle>}
        {hasRightAddon && <StyledCardRightAddon>{rightAddon}</StyledCardRightAddon>}
      </StyledCardHeader>
      <div>
        {description && <StyledCardDescription>{description}</StyledCardDescription>}
        {hasContent && <StyledCardContent>{content}</StyledCardContent>}
      </div>
    </StyledButtonContent>
  );
};
